export enum ACCESS_TYPE {
  AGENT_CUBED = 'AGENTCUBED',
  CURRENTLY_ENROLLED = 'CURRENTLY_ENROLLED',
  NEW_QUOTE = 'NEWQUOTE'
}
